import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

class TicketBox extends Component {
    render() {
        return (
            <div className={`p-3 ${this.props.textColor}`}>
                {
                    this.props.loading
                        ? <Skeleton height={20} />
                        : <div className="ticket-box-title font-bold uppercase">{this.props.titleTicket}</div>
                }
                {
                    this.props.loading
                        ? <div className="flex w-full pt-5">
                            <div className="w-1/3"><Skeleton height={40} /></div>
                            <div className="w-2/3 pl-2"><Skeleton height={40} /> </div>
                        </div>
                        : <div className="flex items-center absolute bottom-4">
                            <div className={`${this.props.iconBoxColor} rounded-md shadow-lg w-12 h-12 flex justify-center items-center`}>
                                {this.props.iconTicket}
                            </div>
                            {!this.props.handlePopup ?
                                <div className="h-12 ml-2 flex items-center text-4xl font-semibold">
                                    {this.props.totalTicket}
                                </div>
                                :
                                <div id={this.props.id} onClick={() => this.props.handlePopup(this.props.titleTicket)} className="h-12 ml-2 flex items-center text-4xl font-semibold cursor-pointer hover:underline">
                                    {this.props.totalTicket}
                                </div>
                            }
                        </div>
                }
            </div>
        );
    }
}

export default TicketBox;